/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type ModelRegistry from "@ember-data/types/registries/model";
import { action } from "@ember/object";
import { service } from "@ember/service";
import type { EmberChangeset } from "ember-changeset";
import { validatePresence } from "ember-changeset-validations/validators";
import type { ValidatorMap } from "ember-changeset/types";
import type IntlService from "ember-intl/services/intl";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import AdverseEventDeclaredJournalEvent from "parog-web/models/adverse-event-declared-journal-event";
import type SemeiaSessionService from "parog-web/services/session";
import validateSometimes from "parog-web/validators/sometimes";

export default class AdverseEventEditionForm extends CrudJournalEventBaseComponent {
  @service declare intl: IntlService;
  @service declare session: SemeiaSessionService;

  static fullComponentId = "adverse-event/edition-form";
  static forcDisplayName = "Symptôme";

  static journalEventClass = AdverseEventDeclaredJournalEvent;

  get validations(): ValidatorMap {
    const validations = this.journalEventClass.validations(this.intl);
    validations["otherDetails"] = validateSometimes(
      [
        validatePresence({
          presence: true,
          description: "Le symptôme"
        })
      ],
      function (this: EmberChangeset) {
        return (this as EmberChangeset).get("adverseEventId") == "other";
      }
    );
    validations["evaScore"] = validateSometimes(
      [
        validatePresence({
          presence: true,
          description: "Le degré de gêne ou de douleur"
        })
      ],
      function (this: EmberChangeset) {
        return Boolean((this as EmberChangeset).get("shouldShowEva"));
      }
    );
    return validations;
  }

  get title(): string {
    return this.intl.t("vital-sign.adverse-events.long-description");
  }

  get otherIsSelected(): boolean {
    return this.changeset.get("adverseEventId") == "other";
  }

  get selectedAdverseEventId(): string {
    return this.changeset.get("adverseEventId");
  }

  @action
  selectAdverseEvent(adverseEvent: ModelRegistry["adverse-event"]): void {
    this.changeset.set("adverseEventId", adverseEvent.id);
    this.changeset.set("shouldShowEva", true);
  }

  get adverseEvents(): ModelRegistry["adverse-event"][] {
    return (
      this.args.patient.followUpReasonRecord?.adverseEvents ?? []
    ).slice();
  }

  get selectedAdverseEvent(): ModelRegistry["adverse-event"] | undefined {
    return this.adverseEvents.find(
      adverseEvent => adverseEvent.id == this.selectedAdverseEventId
    );
  }
}
